<template>
  <div class="body-padding pre-order">
    <subscribe v-model="subscribe"></subscribe>
    <div class="options">
      <div class="address">
        <default-address-item v-show="sendList.length === 0" @click="handleSendAddress"
                              :shou="'寄'"></default-address-item>
        <address-item v-for="item in sendList" :key="item.id" :item="item"
                      @on-change="handleAddressChange($event, item)"
                      @on-contact="handleContactClick"></address-item>

        <div class="add-sender-address" @click="handleSendAddress">
          ╋ 添加寄件地址
        </div>

        <default-address-item v-show="acceptList.length === 0" type="accept" @click="handleAcceptAddress"
                              :shou="'收'"></default-address-item>
        <address-item
            type="accept"
            v-for="item in acceptList"
            :key="item.id"
            :item="item"
            @on-change="handleAddressChange($event, item)"
            @on-contact="handleContactClick"
        ></address-item>
      </div>

      <div class="order-options">
        <cus-cell is-link title="服务网点" :value="city.organName" placeholder="请选择(选填)"
                  @click="handleOrganShow"></cus-cell>
        <cus-cell title="物品信息">
          <div slot="right-icon">
            <van-tag @click="handleProductEvent(1, '服装')"
                     :style="{color:params.productId ===1 ? '#FE9329' : 'rgb(150, 151, 153)'}"
                     style="margin-right: 0.2rem;" plain size="large">
              服装
            </van-tag>
            <van-tag @click="handleProductEvent(2, '箱包')"
                     :style="{color:params.productId ===2 ? '#FE9329' : 'rgb(150, 151, 153)'}"
                     style="margin-right: 0.2rem;" plain size="large">
              箱包
            </van-tag>
            <van-tag @click="handleProductEvent(4, '鞋子')"
                     :style="{color:params.productId ===4 ? '#FE9329' : 'rgb(150, 151, 153)'}"
                     style="margin-right: 0.2rem;" plain size="large">
              鞋子
            </van-tag>
            <van-tag @click="handleProductEvent(6, '普货')"
                     :style="{color:params.productId ===6 ? '#FE9329' : 'rgb(150, 151, 153)'}"
                     plain size="large">普货
            </van-tag>
          </div>
        </cus-cell>

        <!--<div class="card-row">
            <div class="cell__title">寄件方式</div>
            <div class="cell__value">
                <div :class="senderWay==='网点自寄'?'sender__way':'sender__way_gray'"
                     @click="handleSenderWayClick('网点自寄')">
                    网点自寄
                </div>
                <div :class="senderWay==='上门取件'?'sender__way':'sender__way_gray'"
                     @click="handleSenderWayClick('上门取件')">
                    上门取件
                </div>
            </div>
        </div>-->
        <!--                <cus-cell is-link title="期望上门时间" placeholder="" :value="params.planPickupTime"-->
        <!--                          @click="handlePickupTimeAction"></cus-cell>-->
        <!--<div class="card-row">
            <div class="cell__title">物品信息</div>
            <div class="cell__value">
                <input
                        class="goods_info"
                        type="number"
                        ref="input"
                        oninput="value=value.replace(/[^0-9]/g, '')"
                        v-model="params.weight"
                        placeholder="请输入"
                /><span>&nbsp;kg</span>
                <input
                        class="goods_info"
                        type="number"
                        ref="input"
                        onkeyup="this.value= this.value.match(/\d+(\.\d{0,2})?/) ? this.value.match(/\d+(\.\d{0,2})?/)[0] : ''"
                        v-model="params.volume"
                        placeholder="请输入"
                /><span>&nbsp;m³</span>
            </div>
        </div>-->
        <!--<cus-cell is-link title="付款方式" placeholder="到付" :value="params.payMeansName"
                  @click="handlePayAction"></cus-cell>
        <van-action-sheet lazy-render v-model="payVisible" cancel-text="重置" :actions="payAction"
                         @select="handlePaySelect" @cancel="handlePayCancel"></van-action-sheet>
        <cus-cell is-link title="配送方式" placeholder="市场配送" :value="params.deliveryName"
                  @click="handleDeliveryAction"></cus-cell>
        <van-action-sheet
                lazy-render
                v-model="deliveryVisible"
                cancel-text="重置"
                :actions="deliveryAction"
                @select="handleDeliverySelect"
                @cancel="handleDeliveryCancel"
        ></van-action-sheet>-->
        <!-- <cus-cell is-link title="是否需要纤袋" placeholder="否" :value="params.isNeedFiberBag === 1 ? '是' : ''" @click="handleNeedFiberBag"></cus-cell> -->
        <cus-field
            label="提货名"
            placeholder="输入到档口提货所用的名字"
            v-model="params.pickUpName"
            :input-style="{ textAlign: 'right', paddingRight: '0.5rem' }"
        ></cus-field>
        <!--                <cus-cell is-link title="优惠券" :value="couponName" @click="handleCouponShow" ref="couponName"></cus-cell>-->

        <cus-field
            style="border-top: none;"
            label="备注"
            placeholder="给小哥捎句话"
            v-model="params.remark"
            :input-style="{ textAlign: 'right', paddingRight: '0.5rem' }"
        ></cus-field>
      </div>
    </div>
    <div class="split-box">
      <div class="submit-box">
        <div class="payment-box">
          <van-radio-group v-model="radio" @change="handlePayRadio">
            <van-radio style="display: inline-block;margin-right: 0.5rem;" name="2" checked-color="#FE9329"
                       label-position="left">
              到付
            </van-radio>
            <van-radio style="display: inline-block;margin-right: 0.5rem;" name="1" checked-color="#FE9329" label-position="left">
              现付
            </van-radio>
            <van-radio style="display: inline-block" name="3" checked-color="#FE9329" label-position="left">
              月结
            </van-radio>
          </van-radio-group>
        </div>
        <van-button class="submit-btn" type="warning" @click="handleSubmit">下单</van-button>
      </div>
    </div>

    <!-- 服务网点 -->
    <organ-list :visible.sync="organVisible" v-model="city" :title="'附近网点'"></organ-list>
    <!-- 优惠券-->
    <!--        <coupon-popup v-model="couponVisible" :list="couponList" @on-click="handleCouponClick"-->
    <!--                      :currentCoupon="params.couponId"></coupon-popup>-->
    <!--<div class="btn" :style="{ height: height + 'rem',  }">
        <div class="btn-text" @click="handleSubmit">下单</div>
    </div>-->
    <!--<div class="other" :style="{ height:  '3.68rem', paddingTop: top + 'rem' }">-->
    <!--  <cus-field style="border: 1px solid #e5e5e5;" type="textarea" rows="3" placeholder="请输入备注内容"
                 v-model="params.remark"></cus-field>-->
    <!--<div class="shortcut-box">-->
    <!--                <div class="shortcut" @click="cart">需要手推车</div>-->
    <!--                <div class="shortcut" @click="bag">需要纤袋</div>-->
    <!--</div>-->
    <!--<van-button type="warning" round class="order-btn" @click="handleSubmit">下单</van-button>-->
    <!--</div>-->
    <discount-coupon v-show="isShow" @favorable="favorable" :data="dataList"></discount-coupon>
  </div>
</template>

<script>
import {mapState} from 'vuex';

export default {
  name: 'PreOrder',
  components: {
    AddressItem: () => import('./components/AddressItem'),
    DefaultAddressItem: () => import('./components/DefaultAddressItem'),
    CouponPopup: () => import('./components/CouponPopup'),
    Subscribe: () => import('@/components/Subscribe'),
    DiscountCoupon: () => import('./components/DiscountCoupon'),
    OrganList: () => import('@/components/OrganList')
  },
  data() {
    return {
      params: {
        isNeedFiberBag: 0,
        pickUpName: '',
        remark: '',
        couponId: '',
        planPickupTime: '',
        planPickupTimeEnd: '',
        weight: '',
        volume: '',
        organName: '',
        productId: 1,
        productName: '服装',
        payMeansId: '2',
        payMeansName: '到付',
      },
      city: {
        provinceName: '',
        provinceId: '',
        cityName: '',
        cityId: '',
        districtName: '',
        districtId: '',
        organId: '',
        organName: '',
        address: ''
      },
      organVisible: false,
      radio: '2',
      senderWay: '上门取件',
      couponName: '',
      sendAddressVisible: false,
      remarkVisible: false,
      payVisible: false,
      deliveryVisible: false,
      couponVisible: false,
      payAction: [],
      deliveryAction: [],
      couponList: [],
      sendAddressList: [],
      acceptAddressList: [],
      subscribe: this.$route.query.subscribe === '0',
      isShow: false,
      dataList: [],
      couponId: '',
      height: 2.86,
      isBindOrgan: false
    };
  },
  computed: {
    ...mapState({
      sendList: state => state.sendList,
      acceptList: state => state.acceptList,
      //height: state => state.height,
      //top: state => state.top
    })
  },
  watch: {
    "params.couponId"(val) {
      if (!val) {
        this.couponName = `已有${this.couponList.length}张优惠券`
      }
    },
    $route(to, from) {
      if ((to.name == "editSendAddress" && from.name == "PreOrder") || (to.name == "editAcceptAddress" && from.name == "PreOrder") ||
          (to.name == "addSendAddress" && from.name == "PreOrder") || (to.name == "addAcceptAddress" && from.name == "PreOrder")) {
        this.$store.commit("setPath", "preOrder")
      }
    },
    sendList() {
      Object.keys(this.city).forEach(key => {
        if(!this.isBindOrgan && key != 'organId' && key != 'organName') {
          this.city[key] = ''
        }
      })
    }
  },
  mounted() {
    // 微信授权二次校验
    let code = this.$covert.getUrlKey('code')
    let userId = localStorage.getItem("yhb_userId") || this.$cookie.get('yhb_userId')
    let params = {params: {"code": code, "userId": userId, wechatMark: this.$wechatMark, loginType: 5}}
    if (code != null) {
      this.$axios.get('weixin/callBack', params).catch(err => {
        // this.$router.push('/user/bind')
      })
    } else {
      this.$axios.post('weixin/get/openid', params).then(res => {
        if (!res.data.data) this.$router.push('/user/bind')
      })
    }
    this.ready();
    this.getCouponList();
    // this.$refs.couponName.$el.children[2].style.color = '#FE9329'
    let param = {
      page: {
        pageNum: 1,
        pageSize: 10
      },
      params: {
        logisticsCompanyId: this.$logisticsCompanyId
      }
    };
    this.$axios
        .post('discount/coupon/list', param)
        .then(res => {
          console.log(this.couponList)
          this.couponList = res.data.data;
          this.couponName = `已有${this.couponList.length}张优惠券`
        })
        .catch(err => {
        });
  },
  methods: {
    formatDate(d) {
      const year = d.getFullYear();
      let date = d.getDate();
      date = date >= 10 ? date : '0' + date;
      let month = d.getMonth() + 1;

      month = month >= 10 ? month : '0' + month;
      return `${year}-${month}-${date}`;
    },
    loadBindOrgan() {
      this.$toast.loading({
        message: '加载中',
        duration: 0,
        mask: true
      });
      this.getBindOrgan().then(res => {
        let data = res.data.data;
        this.isBindOrgan = false;
        if(data.hasOwnProperty('organId')) {
          this.city.organId = data.organId;
          this.city.organName = data.organName;
          this.isBindOrgan = true;
        }
      }).finally(() => {
        this.$toast.clear();
      });
    },
    ready() {
      if (this.sendList.length !== 0 && this.acceptList !== 0) return;
      this.$toast.loading({
        message: '加载中',
        duration: 0,
        mask: true
      });
      return this.getDefault(1)
          .then(res => {
            let data = res.data.data;
            if (Array.isArray(data)) {
              this.$store.commit('confirmSend', data);
            }
            return this.getDefault(2);
          })
          .then(res => {
            let data = res.data.data;
            if (Array.isArray(data)) {
              this.$store.commit('confirmAccept', data);
            }
          })
          .then(res => {
            this.loadBindOrgan();
          }).finally(() => {
            this.$toast.clear();
          });
    },
    getDefault(type) {
      let params = {
        params: {
          addressType: type,
          defaultAddress: '1'
        }
      };
      return this.$axios.post('merchant/getAddressByType', params);
    },
    getBindOrgan() {
      return this.$axios.post('user/getBindOrderOrgan', {})
    },
    handleSendAddress() {
      this.$router.push('/sendAddressList');
    },
    handleAcceptAddress() {
      this.$router.push('/acceptAddressList');
    },
    handleAddressChange(type, item) {
      if (type === 'send') {
        this.$store.commit('uncheckSend', item);
      } else {
        this.$store.commit('uncheckAccept', item);
      }
    },
    handleContactClick(type) {
      if (type === 'send') {
        this.$router.push('/sendAddressList');
      } else {
        this.$router.push('/acceptAddressList');
      }
    },
    // 寄件方式
    handleSenderWayClick(value) {
      this.senderWay = value
    },
    // 预约提货时间
    handlePickupTimeAction() {

    },
    // 品名
    handleProductEvent(productId, productName) {
      this.params.productId = productId
      this.params.productName = productName
    },
    // 服务网点
    handleOrganShow() {
      if(this.isBindOrgan) {
        this.$toast({
          message: '请联系客服解除/更换绑定网点',
          duration: 1000
        });
        return;
      }
      if (this.sendList.length === 0) {
        this.$toast({
          message: '请选择寄件人',
          duration: 1000
        });
        return;
      }
      Object.keys(this.city).forEach(key => {
        if (this.sendList[0][key]) {
          this.city[key] = this.sendList[0][key]
        }
      })
      this.organVisible = true
    },
    // 支付方式
    handlePayRadio(value) {
      this.$set(this.params, 'payMeansName', value === '1' ? '现付' : (value === '2' ? '到付' : '月结'));
      this.$set(this.params, 'payMeansId', value);
    },
    // 付款方式
    handlePayAction() {
      if (this.payAction.length !== 0) {
        this.payVisible = true;
        return;
      }
      this.$toast.loading({
        message: '加载中...',
        mask: true
      });
      let params = {
        params: 'PAY_MEANS_TYPE'
      };
      this.$axios
          .post('dict/info', params)
          .then(res => {
            let data = res.data.data;
            this.payAction = data.map(item => {
              return {
                name: item.dictName,
                value: item.dictValue
              };
            });
            this.payVisible = true;
            this.$toast.clear();
          })
          .catch(err => {
            this.$toast.clear();
            this.$toast({
              message: err.data.msg,
              duration: 1000
            });
          });
    },
    handlePaySelect(item) {
      this.$set(this.params, 'payMeansName', item.name);
      this.$set(this.params, 'payMeansId', item.value);
      this.payVisible = false;
    },
    handlePayCancel() {
      this.$delete(this.params, 'payMeansName');
      this.$delete(this.params, 'payMeansId');
      this.payVisible = false;
    },

    // 运输方式
    handleDeliveryAction() {
      if (this.deliveryAction.length !== 0) {
        this.deliveryVisible = true;
        return;
      }
      this.$toast.loading({
        message: '加载中...',
        mask: true
      });
      let params = {
        params: 'DELIVERY_TYPE'
      };
      this.$axios
          .post('dict/info', params)
          .then(res => {
            let data = res.data.data;
            this.deliveryAction = data.map(item => {
              return {
                name: item.dictName,
                value: item.dictValue
              };
            });
            this.deliveryVisible = true;
            this.$toast.clear();
          })
          .catch(err => {
            this.$toast.clear();
            this.$toast({
              message: err.data.msg,
              duration: 1000
            });
          });
    },
    handleDeliverySelect(item) {
      this.$set(this.params, 'deliveryName', item.name);
      this.$set(this.params, 'deliveryId', item.value);
      this.deliveryVisible = false;
    },
    handleDeliveryCancel() {
      this.$delete(this.params, 'deliveryName');
      this.$delete(this.params, 'deliveryId');
      this.deliveryVisible = false;
    },
// 		handleNeedFiberBag() {
// 			this.params.isNeedFiberBag = this.params.isNeedFiberBag === 1 ? 0 : 1;
// 		},
    // 优惠券
    handleCouponShow() {
      this.couponVisible = true;
    },
    handleCouponClick(coupon) {
      // 			if (this.params.couponId !== coupon.id) {
      // 				this.params.couponId = coupon.id;
      if (this.params.couponId !== coupon.id) {
        this.couponId = coupon.id;
        this.params.couponId = coupon.id;
        this.couponName = coupon.value + (coupon.type == 0 ? '元' : '折') + (coupon.useType == 0 ? '直减优惠券' : '满减优惠券');
        this.couponVisible = false;
      } else {
        this.params.couponId = this.couponName = '';
        this.couponId = '';
      }
    },
    handleSubmit() {
      if (this.sendList.length === 0) {
        this.$toast({
          message: '请选择寄件人',
          duration: 1000
        });
        return;
      }
      if (this.acceptList.length === 0) {
        this.$toast({
          message: '请选择收件人',
          duration: 1000
        });
        return;
      }
      this.$toast.loading({
        message: '加载中...',
        duration: 1000,
        mask: true
      });
      let defaultParams = {
        payMeansName: '',
        payMeansId: '',
        deliveryName: '',
        deliveryId: '',
        isNeedFiberBag: 0
      };
      let params = Object.assign({}, defaultParams, this.params);
      let acceptAddressItem = this.acceptList[0];
      params.logisticsCompanyId = this.$logisticsCompanyId;
      params.logisticsCompanyName = this.$logisticsCompanyName;
      params.wechatMark = this.$wechatMark;
      params.orderType = this.$loginType;
      params.packId = this.sendList[0].packId || '1';
      params.packName = this.sendList[0].packName || '纤袋';
      params.consigneePhone = acceptAddressItem.concatPhone;
      params.consigneeName = acceptAddressItem.name;
      params.consigneeAddress = acceptAddressItem.address;
      params.consigneeProvinceId = acceptAddressItem.provinceId;
      params.consigneeProvinceName = acceptAddressItem.provinceName;
      params.consigneeCityId = acceptAddressItem.cityId;
      params.consigneeCityName = acceptAddressItem.cityName;
      params.consigneeDistrictId = acceptAddressItem.districtId;
      params.consigneeDistrictName = acceptAddressItem.districtName;
      params.consigneeStreetId = acceptAddressItem.streetId;
      params.consigneeStreetName = acceptAddressItem.streetName;
      params.consigneeId = acceptAddressItem.id;
      params.lat = this.sendList[0].lat || 0;
      params.lng = this.sendList[0].lng || 0;
      params.couponId = this.couponId;

      params.staOrderDetail = this.sendList.map(val => {
        if (val.planDeliveryDate) {
          let r = this.getPlanPickUpTime(val.planDeliveryDate);
          val.planPickupTime = r[0]
          val.planPickupTimeEnd = r[1]
        }
        return {
          clothingCityId: val.clothingCityId,
          consignorName: val.name,
          consignorPhone: val.concatPhone,
          consignorProvinceName: val.provinceName,
          consignorProvinceId: val.provinceId,
          consignorCityName: val.cityName,
          consignorCityId: val.cityId,
          consignorDistrictName: val.districtName,
          consignorDistrictId: val.districtId,
          consignorStreetName: val.streetName,
          consignorStreetId: val.streetId,
          consignorAddress: val.address,
          deliveryWeight: val.deliveryWeight,
          goodsNumber: val.goodsNumber || 0,
          lat: val.lat || 0,
          lng: val.lng || 0,
          planDeliveryDate: val.planDeliveryDate || '',
          packId: val.packId || '',
          packName: val.packName || '',
          consignorId: val.id,
          needWheelbarrow: val.needWheelbarrow,
          planPickupTime: val.planPickupTime || '',
          planPickupTimeEnd: val.planPickupTimeEnd || ''
        };
      });
      params.planPickupTime = params.staOrderDetail[0].planPickupTime
      params.planPickupTimeEnd = params.staOrderDetail[0].planPickupTimeEnd
      params.senderWay = this.senderWay
      params.organId = this.city.organId
      params = {params};
      this.$axios
          .post('merchant/addOrder', params)
          .then(res => {
            this.$toast('下单成功');
            this.$toast.clear();
            this.isShow = false;
            this.params = {
              isNeedFiberBag: 0,
              pickUpName: '',
              remark: '',
              couponId: '',
              planPickupTime: '',
              planPickupTimeEnd: '',
              weight: '',
              volume: '',
              organName: '',
              productId: 1,
              productName: '服装',
              payMeansId: '2',
              payMeansName: '到付',
            }
            this.$store.commit('confirmSend', []);
            this.$store.commit('confirmAccept', [])
            this.$router.push('/order/detail?t=true&id=' + res.data.data)
          })
          .catch(err => {
            if (err.message === 'Network Error') {
              this.$toast('网络异常，请重试');
            } else {
              this.$toast(err.message)
            }
          });
    },
    PrefixInteger(num, length) {
      return ("0000000000000000" + num).substr(-length);
    },
    getPlanPickUpTime(dateStr) {
      let result = []
      let expectDate = new Date();
      if (dateStr.indexOf('明天') !== -1) {
        expectDate.setDate(expectDate.getDate() + 1);
      } else if (dateStr.indexOf('后天') !== -1) {
        expectDate.setDate(expectDate.getDate() + 2);
      }
      let dateStrTemp = dateStr.replace('今天', '').replace('明天', '').replace('后天', '')
      if (dateStrTemp === '一小时内') {
        result[0] = this.formatDate(expectDate) + ' ' + this.PrefixInteger(expectDate.getHours(), 2) + ':' + this.PrefixInteger(expectDate.getMinutes(), 2) + ':' + this.PrefixInteger(expectDate.getSeconds(), 2);
        expectDate.setHours(expectDate.getHours() + 1);
        result[1] = this.formatDate(expectDate) + ' ' + this.PrefixInteger(expectDate.getHours(), 2) + ':' + this.PrefixInteger(expectDate.getMinutes(), 2) + ':' + this.PrefixInteger(expectDate.getSeconds(), 2);
      } else {
        let d = dateStrTemp.split("-");
        result[0] = this.formatDate(expectDate) + ' ' + d[0] + ":00";
        result[1] = this.formatDate(expectDate) + ' ' + d[1] + ":00";
      }
      return result;
    },
    //优惠
    favorable() {
      this.isShow = false;
    },
    //备注
    cart() {
      if (this.params.remark.indexOf('需要手推车') >= 0) {
        return;
      }
      this.params.remark += '需要手推车，';
    },
    bag() {
      if (this.params.remark.indexOf('需要纤袋') >= 0) {

        return;
      }
      this.params.remark += '需要纤袋，';
    },
    getCouponList() {
      let parse = {
        page: {
          pageNum: 1,
          pageSize: 10
        },
        params: {}
      };
      // 优惠券列表
      this.$axios
          ///discount/coupon/list
          .post('coupon/canReceive/list', parse)
          // .post('discount/coupon/list', parse)
          .then(res => {
            if (res.data.data.list.length > 0) {
              this.isShow = true;
              let len = res.data.data.list[0].canReceiveValue;
              for (let i = 0; i < len; i++) {
                this.dataList.push(res.data.data.list[0]);
              }
              this.dataList = res.data.data.list;
            } else {
              this.isShow = false;
              return;
            }
          })
          .catch(err => {
            this.isShow = false;
          });
    }
  }
};
</script>

<style scoped lang="scss">
.pre-order {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding-bottom: 1.5rem;

  .add-sender-address {
    margin-top: 0.05rem;
    margin-bottom: 0.13rem;
    text-align: center;
    height: 1.07rem;
    line-height: 1.07rem;
    font-size: 0.43rem;
    color: #2E2E2E;
    font-weight: bold;
    background-color: #fff;
  }
}

.order-options {
  background: #fff;
  margin-top: 0.13rem;

  .card-row {
    display: flex;
    flex-direction: row;
    font-size: 0.41rem;
    padding: 0 0.32rem;
    height: 1.33rem;
    line-height: 1.33rem;
    align-items: center;
    transition: background-color 300ms;
    border-bottom: 1px solid #e5e5e5;

    .cell__title {
      flex: 1;
    }

    .cell__value {
      text-align: right;

      span {
        color: #2f2f2f;
      }
    }

    .sender__way {
      display: inline-block;
      border: 1px solid #ff976a;
      color: #FE9329;
      border-radius: 1.35rem;
      height: 0.7rem;
      line-height: 0.7rem;
      padding: 0.03rem 0.3rem;
      background-color: #fff4ea;
      font-size: 0.35rem;
      margin-left: 0.5rem;
    }

    .sender__way_gray {
      display: inline-block;
      border: 1px solid #a6a6a6;
      color: #a6a6a6;
      border-radius: 1.35rem;
      height: 0.7rem;
      line-height: 0.7rem;
      padding: 0.03rem 0.3rem;
      font-size: 0.35rem;
      margin-left: 0.5rem;
    }

    .goods_info {
      margin-left: 0.35rem;
      height: 100%;
      line-height: 0.33rem;
      padding: 0.13rem 0.08rem;
      width: 1.8rem;
      background: rgba(241, 241, 241, 1);
      box-sizing: border-box;
      outline: none;
      border: 0;
      text-align: left;
      color: #4f4f4f;

      &::-webkit-input-placeholder {
        color: #8f8f8f;
        font-size: .3rem;
        line-height: .5rem;
      }
    }
  }

  &__item {
    height: 1.33rem;
    line-height: 1.33rem;
    padding: 0 0.31rem;
    font-size: 0.4rem;
    color: #4f4f4f;
    border-bottom: 1px solid #e5e5e5;
    position: relative;
    transition: background 100ms;

    &::after {
      position: absolute;
      right: 0.31rem;
      top: 50%;
      transform: translateY(-50%);
      content: '';
      width: 0.21rem;
      height: 0.39rem;
      background: url('../../assets/arrow-line.png') center / 100% no-repeat;
    }

    &:active {
      background: #f2f3f5;
    }
  }
}

.btn {
  position: fixed;
  bottom: 0;
  width: 9.47rem;
  height: 2.56rem;
  //background: rgba(255, 255, 255, 1);

  .btn-text {
    width: 4rem;
    height: 1.07rem;
    background: rgba(254, 147, 41, 1);
    border-radius: 1rem;
    color: #fff;
    line-height: 1.07rem;
    text-align: center;
    font-size: 0.48rem;
    margin: 1.09rem auto;
  }
}


.other {
  text-align: center;
  //background-color: #fff;
  margin-top: 0.13rem;
  padding: 0.2rem 0.33rem 1.2rem;

  .remark-btn {
    color: #8f8f8f;
    font-size: 0.32rem;
    text-align: center;
    position: relative;
    margin-top: 0.43rem;
    margin-bottom: 0.36rem;

    &:before {
      content: '';
      position: absolute;
      width: 0.39rem;
      height: 0.13rem;
      top: -0.15rem;
      background: url('../../assets/icon_arrow.png') center / 100% no-repeat;
      left: 50%;
      transform: translateX(-50%);
    }
  }
}

.order-btn {
  width: 6.67rem;
}

.shortcut-box {
  margin-top: 10px;
  overflow: hidden;
}

.shortcut {
  float: left;
  padding: 0 0.3rem;
  height: 0.67rem;
  line-height: 0.67rem;
  text-align: center;
  color: rgba(254, 147, 41, 1);
  border: 1px solid rgba(254, 147, 41, 1);
  border-radius: 0.34rem;
  margin-left: 0.266666rem;
  font-size: 0.32rem;
}

.split-box {
  text-align: center;
  flex: 1;
  position: fixed;
  bottom: 0;
  right: 0.27rem;
  left: 0.27rem;

  &__input {
    position: relative;

    .f-tip {
      &:active {
        display: none;
      }

      position: absolute;
      top: 0;
      left: 0;
      display: flex;
      align-items: center;
      justify-content: center;
      width: 100%;
      height: 100%;
    }
  }
}

.submit-btn {
  height: 1.07rem;
  flex: 1;
  border-radius: unset;
}

.submit-box {
  height: 1.07rem;
  display: flex;
  font-size: 0.41rem;

  .payment-box {
    flex: 3;
    display: flex;
    align-items: center;
    background-color: #fff;
    text-align: left;
    padding-left: 0.36rem;
  }

  .payment_radio {
    display: inline-block;
  }
}

.options {
  width: 9.47rem;
  margin: auto;
  margin-top: 0.133333rem;
  overflow-y: scroll;
  -webkit-overflow-scrolling: touch;

  &::-webkit-scrollbar {
    display: none;
  }
}
</style>
